<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBSettlementForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBSettlementList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBSettlementForm from './Form.vue'

export default {
  components: {
    EXSBSettlementForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbsettlement/update/isLoading',
      error: 'exsbsettlement/update/error',
      deleteError: 'exsbsettlement/del/error',
      deleteLoading: 'exsbsettlement/del/isLoading',
      created: 'exsbsettlement/create/created',
      deleted: 'exsbsettlement/del/deleted',
      retrieved: 'exsbsettlement/update/retrieved',
      updated: 'exsbsettlement/update/updated',
      violations: 'exsbsettlement/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBSettlementList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbsettlement/create/reset',
      deleteItem: 'exsbsettlement/del/del',
      delReset: 'exsbsettlement/del/reset',
      retrieve: 'exsbsettlement/update/retrieve',
      updateReset: 'exsbsettlement/update/reset',
      update: 'exsbsettlement/update/update',
      updateRetrieved: 'exsbsettlement/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbsettlement ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
